import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotDivide = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M20.355 39.89c6.245.404 13.26-.103 17.124-4.986 3.843-4.857 2.624-11.707.738-17.59-1.664-5.19-5.317-9.255-10.164-11.812C22.9 2.785 16.686.48 11.568 3.26c-4.952 2.69-5.313 9.164-6.38 14.664-1 5.145-2.35 10.605.636 14.928 3.205 4.641 8.872 6.67 14.53 7.038Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M8.332 20h23.333m-8.332-10a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Zm0 20a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotDivide.displayName = "SpotDivide";
